module.exports = __webpack_public_path__ + "static/media/open-positions-bkg.fd6214b0.png";